<template>
  <div :class="[ns.b()]">
    <div
      v-if="props.noSearchForm"
      class="el-form-base-head el-form-base-search"
    >
      <div class="el-form-base-inline-box">
        <el-form
          v-if="props.noSearchFormLeft"
          ref="formInlineRef"
          :inline="true"
          :model="props.formInline"
          label-suffix=""
          :is-search="true"
          @submit.prevent
        >
          <template v-if="searchConditionArr.length === 0">
            <slot name="searchForm" :form-inline="props.formInline" />
          </template>
          <template v-if="searchConditionArr.length > 0">
            <el-form-item
              v-for="(item, index) in searchConditionArr"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
              <component
                :is="item.searchType"
                v-model="props.formInline[item.prop]"
                :code="item.searchValue"
              />
            </el-form-item>
          </template>
          <el-form-item v-if="props.hasFlow" label="流程状态">
            <el-select
              v-model="approvalStatus"
              :style="getFlowWidth"
              :clearable="true"
              @change="handleChangeFlowStatus"
            >
              <el-option
                v-for="item in getFlowStatus"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="props.noFormInlineBtn">
            <slot name="searchLeft" />
            <el-button
              v-if="props.noSearch"
              :type="searchTypeStr"
              :icon="Search"
              native-type="submit"
              @click="search"
              >{{ localeSearchBtnText }}</el-button
            >
            <el-button
              v-if="props.noClear"
              :type="clearTypeStr"
              :icon="Delete"
              @click="clear"
              >{{ localeClearBtnText }}</el-button
            >
            <slot name="searchRight" />
          </el-form-item>
        </el-form>
      </div>
      <div
        v-if="props.noOperation && !isButtonAreaType"
        class="el-form-base-inline-operation"
      >
        <el-button
          v-if="hiddenAddBtn"
          :icon="Plus"
          :type="addTypeStr"
          @click="add"
          >{{ localeAddBtnText }}</el-button
        >
        <el-button
          v-if="hiddenEditBtn"
          :icon="EditPen"
          :type="updateTypeStr"
          @click="update"
          >{{ localeEditBtnText }}</el-button
        >
        <el-button
          v-if="hiddenDelBtn"
          :icon="Delete"
          :type="deleteTypeStr"
          @click="del"
          >{{ localeDelBtnText }}</el-button
        >
        <slot name="toolbar" />
        <el-button
          v-if="hiddenBatchBtn"
          :icon="Delete"
          :type="batchDelTypeStr"
          @click="batchDel"
          >{{ localeBatchBtnText }}</el-button
        >
        <template v-if="props.noExpandsBtn">
          <el-button
            v-show="props.rowKey && !tableDefaultExpandAll"
            class="el-form-base-expand-btn"
            :type="expandTypeStr"
            :icon="DArrowRight"
            @click="handleToggleExpand"
          >
            {{ localeExpandBtnText }}
          </el-button>
          <el-button
            v-show="props.rowKey && tableDefaultExpandAll"
            :type="expandTypeStr"
            class="el-form-base-fold-btn"
            :icon="DArrowRight"
            @click="handleToggleExpand"
          >
            {{ localeFoldBtnText }}
          </el-button>
        </template>
      </div>
    </div>
    <slot name="tabList" />
    <div class="el-form-base-body">
      <div
        v-if="props.noOperation && isButtonAreaType"
        class="el-form-base-operation"
      >
        <div class="el-form-base-operation-left">
          <el-button v-if="hiddenAddBtn" :type="addTypeStr" :icon="Plus">{{
            localeAddBtnText
          }}</el-button>
          <el-button
            v-if="hiddenEditBtn"
            :type="updateTypeStr"
            :icon="EditPen"
            >{{ localeEditBtnText }}</el-button
          >
          <el-button v-if="hiddenDelBtn" :type="deleteTypeStr" :icon="Delete">{{
            localeDelBtnText
          }}</el-button>
          <slot name="toolbar" />
          <el-button
            v-if="hiddenBatchBtn"
            :type="batchDelTypeStr"
            :icon="Delete"
            >{{ localeBatchBtnText }}</el-button
          >
        </div>
        <div v-if="props.noRefreshBtn" class="el-form-base-operation-right" />
      </div>
      <slot name="table">
        <form-base-table
          ref="peTable"
          v-if="isShowDataTable"
          v-loading="tableLoading"
          element-loading-text="正在加载中..."
          :row-key="props.rowKey"
          :primary-key="props.primaryKey"
          :row-single="props.rowSingle"
          :columns="getColumns"
          :table-data="tableData"
          :pagination="pagination"
          :no-batch-btn="props.noBatchBtn"
          :no-pagination="props.noPagination"
          :no-table-index="props.noTableIndex"
          :table-lazy="props.tableLazy"
          :is-virtually-table="props.isVirtuallyTable"
          :table-transform="props.tableTransform"
          :selection-width="props.selectionWidth"
          :selection-align="props.selectionAlign"
          :selection-fixed="props.selectionFixed"
          :index-width="props.indexWidth"
          :index-align="props.indexAlign"
          :index-fixed="props.indexFixed"
          :span-method="props.spanMethod"
          :default-expand-all="tableDefaultExpandAll"
          :table-load="handleTableLoad"
          :row-class-name="props.rowClassName"
          :cell-class-name="props.cellClassName"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @table-current-change="handleTableCurrentChange"
          @table-selection-change="handleTableSelectionChange"
          @table-row-dblclick="handleRowDblclick"
          @click-info="handleClickInfo"
          @table-sort-change="handleTableSortChange"
        >
          <template #tableWarp>
            <slot name="tableWarp" />
          </template>
        </form-base-table>
      </slot>
    </div>

    <template v-if="props.dialogType === 'dialog'">
      <el-dialog
        v-model="dialogVisible"
        :title="dialogTitle"
        :close-on-click-modal="false"
        :width="props.dialogWidth"
        :before-close="beforeClose"
        modal-class="form-base-dialog"
        draggable
      >
        <slot name="addWarp">
          <el-form
            ref="addFormRef"
            :model="cloneAddForm"
            :rules="props.rules"
            :label-width="props.labelWidth"
            status-icon
            :disabled="addFormDisabled"
            :validateOnRuleChange="props.validateOnRuleChange"
          >
            <slot name="add" :add-form="cloneAddForm" />
          </el-form>
        </slot>
        <template #footer>
          <span class="dialog-footer">
            <slot name="dialog-footer-left" />
            <el-button
              v-if="props.noCancelBtn"
              :type="cancelTypeStr"
              @click="beforeClose()"
              >{{ t('el.formBase.cancel') }}</el-button
            >
            <slot name="dialog-footer-center" />
            <template v-if="!hasFlow">
              <el-button
                v-if="!addFormDisabled && props.noConfirmBtn"
                :type="saveTypeStr"
                :loading="formBtnLoading"
                @click="save(addFormRef)"
              >
                {{ localeConfirmBtnText }}
              </el-button>
            </template>
            <template v-else>
              <el-button
                v-if="props.noStorageBtn"
                type="colour-10"
                :loading="storageBtnLoading"
                @click="storage"
                >{{ localeStorageBtnText }}</el-button
              >
              <el-button
                v-if="!draftBtnDisabled && props.noDraftBtn"
                :type="draftBtnTypeStr"
                :loading="draftBtnLoading"
                @click="draft(addFormRef)"
                >{{ localeDraftBtnText }}</el-button
              >
              <el-button
                v-if="!initiateProcessBtnDisabled && props.noInitiateProcessBtn"
                :type="initiateProcessBtnTypeStr"
                :loading="initiateProcessBtnLoading"
                @click="startProcess(addFormRef)"
                >{{ localeInitiateProcessBtnText }}</el-button
              >
              <pit-view-process
                v-if="props.operatingTypeProps != 'info' && props.hasFlow"
                :flow-code="props.flowCode"
                :bid-id="cloneAddForm.bidId"
              />
            </template>
            <slot name="dialog-footer-right" />
          </span>
        </template>
      </el-dialog>
    </template>
    <template v-else>
      <el-dialog-header
        v-model="dialogHeaderVisible"
        :title="dialogTitle"
        :width="props.dialogWidth"
        :before-close="beforeClose"
        :close-on-click-modal="false"
        :no-cancel-btn="props.noCancelBtn"
        modal-class="form-base-dialog-header"
      >
        <slot name="addWarp">
          <el-form
            ref="addFormRef"
            :model="cloneAddForm"
            :rules="props.rules"
            :label-width="props.labelWidth"
            status-icon
            :disabled="addFormDisabled"
            :validateOnRuleChange="props.validateOnRuleChange"
          >
            <slot name="add" :add-form="cloneAddForm" />
          </el-form>
        </slot>
        <template #footer-right>
          <slot name="dialog-footer-left" />
          <slot name="dialog-footer-center" />
          <template v-if="!hasFlow">
            <el-button
              v-if="!addFormDisabled && props.noConfirmBtn"
              :type="saveTypeStr"
              :loading="formBtnLoading"
              @click="save(addFormRef)"
            >
              {{ localeConfirmBtnText }}
            </el-button>
          </template>
          <template v-else>
            <el-button
              v-if="props.noStorageBtn"
              type="colour-10"
              :loading="storageBtnLoading"
              @click="storage"
              >{{ localeStorageBtnText }}</el-button
            >
            <el-button
              v-if="!draftBtnDisabled && props.noDraftBtn"
              :type="draftBtnTypeStr"
              :loading="draftBtnLoading"
              @click="draft(addFormRef)"
              >{{ localeDraftBtnText }}</el-button
            >
            <el-button
              v-if="!initiateProcessBtnDisabled && props.noInitiateProcessBtn"
              :type="initiateProcessBtnTypeStr"
              :loading="initiateProcessBtnLoading"
              @click="startProcess(addFormRef)"
              >{{ localeInitiateProcessBtnText }}</el-button
            >
            <pit-view-process
              v-if="props.operatingTypeProps != 'info' && props.hasFlow"
              :flow-code="props.flowCode"
              :bid-id="cloneAddForm.bidId"
            />
          </template>
          <slot name="dialog-footer-right" />
        </template>
      </el-dialog-header>
    </template>

    <component
      :is="customSetUpRender"
      v-if="props.isSetUpRender"
      @click="setupClick"
    />
  </div>
</template>

<script setup lang="tsx">
import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  provide,
  reactive,
  ref,
  toRefs,
  watch,
} from 'vue'
import { DArrowRight, Delete, EditPen, Plus, Search } from 'pit-element-icons'
import { cloneDeep } from 'lodash-unified'
import {
  useGlobalProperties,
  useLocale,
  useNamespace,
} from '@pit-element-plus/hooks'
import { getObjectValue, renderTemplate } from '@pit-element-plus/utils'
import { ElMessage, ElMessageBox } from '@pit-element-plus/components'
import { formBaseEmits, formBaseProps } from './form-base'
import formBaseTable from './form-base-table.vue'
import useFormBase from './use-form-base'
import useFormBaseLocale from './use-form-base-locale'
import { formBaseContextKey } from './constants'
import type { FormBaseColumnsItem } from './form-base'
import type { FormInstance } from '@pit-element-plus/components/form'
import type { FormBaseContext } from './types'

defineOptions({
  name: 'ElFormBase',
})

const ns = useNamespace('form-base')
const { t } = useLocale()
const global = useGlobalProperties()
const props = defineProps(formBaseProps)
const emit = defineEmits(formBaseEmits)

const {
  pageSize,
  pageNum,
  hiddenAddBtn,
  hiddenEditBtn,
  hiddenDelBtn,
  hiddenBatchBtn,
  isButtonAreaType,
  searchTypeStr,
  clearTypeStr,
  addTypeStr,
  updateTypeStr,
  deleteTypeStr,
  batchDelTypeStr,
  expandTypeStr,
  saveTypeStr,
  cancelTypeStr,
  paginationTotal,
  draftBtnTypeStr,
  initiateProcessBtnTypeStr,
  columnsStr,
  flowStatusData,
  defaultFlowStatus,
  flowStatusWidth,
  customSetUpRender,
  customSetUpCallback,
  paginationPageSizeStr,
  paginationPageNumStr,
} = useFormBase(props)

const {
  localeAddBtnText,
  localeEditBtnText,
  localeDelBtnText,
  localeBatchBtnText,
  localeExpandBtnText,
  localeFoldBtnText,
  localeSearchBtnText,
  localeClearBtnText,
  localeConfirmBtnText,
  localeTextAddSuccess,
  localeTextEditSuccess,
  localeTextDelSuccess,
  localeTextDelStr,
  localeTextEmptyOption,
  localeTextEmptyOptionOne,
  localeStorageBtnText,
  localeDraftBtnText,
  localeInitiateProcessBtnText,
  localeTextDraftSuccess,
  localeTextProcessSuccess,
} = useFormBaseLocale(props)

const tableData: any = ref([])
const tableLoading = ref(false)
const isShowDataTable = ref(true)
const pagination = ref({
  pageSize: pageSize.value,
  pageNum: pageNum.value,
  total: 0,
})

const formInlineRef = ref<FormInstance>()
const addFormRef = ref<FormInstance>()
const dialogVisible = ref(false)
const dialogHeaderVisible = ref(false)
const formBtnLoading = ref(false)
const operatingType = ref('add')
const dialogTitle = ref(t('el.formBase.addBtnText'))
const cloneAddForm = reactive(JSON.parse(JSON.stringify(props.addForm || {})))
const addFormDisabled = ref(false)

const tableDefaultExpandAll = ref(props.defaultExpandAll)

const draftBtnLoading = ref(false)
const initiateProcessBtnLoading = ref(false)
const draftBtnDisabled = ref(false)
const initiateProcessBtnDisabled = ref(false)
const storageBtnLoading = ref(false)

const approvalStatus = ref(defaultFlowStatus.value)

const peTable = ref()
const currentRow = ref(null)
const multipleSelection = ref([])

const orderArray: any = ref([])

const searchConditionArr: Record<string, any> = ref([])

watch(
  () => props.addForm,
  (val) => {
    Object.assign(cloneAddForm, cloneDeep(val))
  },
  { deep: true, immediate: true }
)

watch(
  () => dialogVisible.value,
  (val: boolean) => {
    emit('update:isDialogVisible', val)
  }
)

watch(
  () => dialogHeaderVisible.value,
  (val: boolean) => {
    emit('update:isDialogVisible', val)
  }
)

let vm: any

onMounted(() => {
  vm = getCurrentInstance()
  if (props.isDefaultQuery) {
    query()
  }
})

const getColumns = computed(() => {
  const route = global.$route?.meta?.menuListData
  const sortEncoding = global.$route?.meta?.sortEncoding
  const columns: any = cloneDeep(props.columns)
  let routerColumns: any = []
  let searchCondition: any = []
  if (props.isSetUpRender && route && route.length > 0) {
    route.forEach((item: any) => {
      const findColumn = columns.find((k: any) => k.prop === item.prop)
      const obj = {
        ...findColumn,
        prop: item.prop,
        label: item.label,
      }
      if (Object.prototype.hasOwnProperty.call(item, 'isDetails')) {
        obj.isDetails = item.isDetails
      }
      if (Object.prototype.hasOwnProperty.call(item, 'width')) {
        obj.width = item.width
      }
      if (Object.prototype.hasOwnProperty.call(item, 'align')) {
        obj.align = item.align
      }
      if (Object.prototype.hasOwnProperty.call(item, 'showOverflow')) {
        obj.showOverflow = item.showOverflow
      }
      if (Object.prototype.hasOwnProperty.call(item, 'hidden')) {
        obj.hidden = item.hidden
      }
      if (Object.prototype.hasOwnProperty.call(item, 'resizable')) {
        obj.resizable = item.resizable
      }
      if (Object.prototype.hasOwnProperty.call(item, 'sortable')) {
        obj.sortable = item.sortable
      }
      routerColumns.push(obj)
      // 处理搜索条件
      if (item.isSearch) {
        let searchItem = {
          prop: item.prop,
          label: item.label,
          searchType: item.searchType,
          searchValue: item.searchValue,
        }
        searchCondition.push(searchItem)
      }
    })
    searchConditionArr.value = searchCondition
  } else {
    // 配置了排序编码则去匹配规则
    if (sortEncoding) {
      const allSort = global.$pinia?.state?.value?.base?.allSort || {}
      const sortArr = allSort[sortEncoding] || []
      sortArr.forEach((item: any) => {
        const obj = columns.find((i: any) => i.prop === item.value)
        if (obj) {
          obj.sortable = item.defaultOption
        }
      })
    }
    routerColumns = columns
  }
  if (props.hasFlow) {
    const flowStatus = routerColumns.filter(
      (item: any) => item.label === '流程状态'
    )
    if (flowStatus.length === 0) {
      const index: number = routerColumns.length - 1
      routerColumns.splice(index, 0, {
        prop: 'approvalStatus',
        label: '流程状态',
        align: global.$TABLE_SIZE.FLOW_STATUS_ALIGN,
        width: props.tableFlowStatusWidth,
        render: (_params: any) => (
          <pit-flow-table-status
            status={_params.approvalStatus}
            row={_params}
            rowKey={props.flowVersion}
          />
        ),
        showOverflow: true,
      })
    }
  }
  if (columnsStr.value && columnsStr.value.length > 0) {
    routerColumns = routerColumns.map((item: any) => {
      // @ts-ignore
      const newItem: any = columnsStr.value.find((k) => k.label === item.label)
      if (newItem) {
        item.width = newItem.width
        item.align = newItem.align
        item.showOverflow = newItem.showOverflow
        item.dateFormatter = newItem.dateFormatter
        item.renderTooltip = newItem.renderTooltip
        item.hidden = newItem.hidden
      }
      return item
    })
  }
  return routerColumns
})

const getFlowWidth = computed(() => {
  if (props.flowStatusWidth) {
    return { width: `${props.flowStatusWidth}px` }
  }
  if (flowStatusWidth.value) {
    return { width: `${flowStatusWidth.value}px` }
  }
  return {}
})

const getFlowStatus = computed((): any => {
  return flowStatusData.value
})

const clear = () => {
  if (props.clearCallback) {
    props.clearCallback()
    clearFn()
  } else if (props.clearPreventCallback) {
    props.clearPreventCallback()
  } else {
    clearFn()
  }
}

const clearFn = () => {
  approvalStatus.value = defaultFlowStatus.value
  formInlineRef.value?.resetFields()
  multipleSelection.value = []
  nextTick(() => {
    query()
  })
}

const query: FormBaseContext['query'] = () => {
  const fn = (params?: any) => {
    tableLoading.value = true
    peTable?.value?.setRefreshTable(false)
    if (props.queryInterface) {
      const url = renderTemplate(props.queryInterface, props.formInline)
      if (props.hasFlow) {
        props!.formInline!.approvalStatus = approvalStatus.value
      }
      let orderBy = ''
      if (orderArray.value && orderArray.value.length > 0) {
        orderArray.value.forEach((item: any) => {
          orderBy += `${item.prop} ${
            item.order === 'ascending' ? 'asc' : 'desc'
          }, `
        })
        orderBy = orderBy.slice(0, Math.max(0, orderBy.length - 2))
      }
      const paginationPageSize: string = paginationPageSizeStr.value as string
      const paginationPageNum: string= paginationPageNumStr.value as string
      global.$http
        .request({
          url,
          method: props.queryInterfaceMethod,
          [props.queryInterfaceMethod === 'GET' ? 'params' : 'data']: {
            [paginationPageSize]: pagination.value.pageSize,
            [paginationPageNum]: pagination.value.pageNum,
            orderBy,
            ...props.formInline,
            ...params,
          },
        })
        .then((res: any) => {
          if (res.data && res.data.list) {
            tableData.value = res.data.list
            pagination.value.total = getObjectValue(
              res.data,
              paginationTotal.value,
              0
            )
          } else {
            tableData.value = []
            pagination.value.total = 0
          }
          if (res.data.length > 0) {
            tableData.value = res.data
            pagination.value.total = 0
          } else {
            tableData.value = res.data.list
            pagination.value.total = getObjectValue(
              res.data,
              paginationTotal.value,
              0
            )
          }
          emit('result-table-back', tableData.value, res)
        })
        .finally(() => {
          tableLoading.value = false
          peTable?.value?.setRefreshTable(true)
        })
    } else {
      tableLoading.value = false
    }
  }
  if (props.searchBeforeCallbackPrevent) {
    props.searchBeforeCallbackPrevent(vm).then((params: any) => {
      fn(params)
    })
  } else {
    fn()
  }
}

const search: FormBaseContext['search'] = () => {
  pagination.value.pageNum = 1
  multipleSelection.value = []
  if (props.searchBeforeCallback) {
    const next = props.searchBeforeCallback()
    if (next) {
      query()
    }
  } else {
    query()
  }
}

const handleTableLoad = (tree: any) => {
  return new Promise((resolve, reject) => {
    if (props.queryInterface) {
      const params = {
        ...props.formInline,
      }
      params[props.lazyKey] = tree[props.lazyKey]
      const url = renderTemplate(props.queryInterface, params)
      global.$http
        .request({
          url,
          method: props.queryInterfaceMethod,
          [props.queryInterfaceMethod === 'GET' ? 'params' : 'data']: {
            pageSize: pagination.value.pageSize,
            pageNumber: pagination.value.pageNum,
            ...params,
          },
        })
        .then((res: any) => {
          if (res.data.length > 0) {
            resolve(res['data'])
          }
        })
        .catch((e: any) => {
          reject(e)
        })
    }
  })
}

const add: FormBaseContext['add'] = () => {
  if (props.addBeforeCallback) {
    const next = props.addBeforeCallback()
    if (next) {
      operatingType.value = 'add'
      const addTitle =
        props.customizeDialogTitle && props.customizeDialogTitle.addTitle
      dialogTitle.value = addTitle ? addTitle : t('el.formBase.addBtnText')
      emit('update:operatingTypeProps', 'add')
      // 判断是弹窗还是全屏弹窗
      if (props.dialogType === 'dialog') {
        dialogVisible.value = true
      } else {
        dialogHeaderVisible.value = true
      }
    }
  } else if (props.addBeforeAsyncCallback) {
    props.addBeforeAsyncCallback().then((next: boolean) => {
      if (next) {
        operatingType.value = 'add'
        const addTitle =
          props.customizeDialogTitle && props.customizeDialogTitle.addTitle
        dialogTitle.value = addTitle ? addTitle : t('el.formBase.addBtnText')
        emit('update:operatingTypeProps', 'add')
        // 判断是弹窗还是全屏弹窗
        if (props.dialogType === 'dialog') {
          dialogVisible.value = true
        } else {
          dialogHeaderVisible.value = true
        }
      }
    })
  } else {
    operatingType.value = 'add'
    const addTitle =
      props.customizeDialogTitle && props.customizeDialogTitle.addTitle
    dialogTitle.value = addTitle ? addTitle : t('el.formBase.addBtnText')
    emit('update:operatingTypeProps', 'add')
    // 判断是弹窗还是全屏弹窗
    if (props.dialogType === 'dialog') {
      dialogVisible.value = true
    } else {
      dialogHeaderVisible.value = true
    }
  }
}

const update = () => {
  let selection: string | any[] = []
  if (props.rowSingle) {
    selection = multipleSelection.value
  } else {
    selection = currentRow.value ? [currentRow.value] : []
  }
  if (selection.length === 0) {
    ElMessage({
      type: 'warning',
      message: localeTextEmptyOption.value,
      duration: props.duration,
    })
  } else if (selection.length >= 2) {
    ElMessage({
      type: 'warning',
      message: localeTextEmptyOptionOne.value,
      duration: props.duration,
    })
  } else {
    info(selection[0][props.primaryKey ? props.primaryKey : ''])
  }
}

const info: FormBaseContext['info'] = (primaryKey: string, data?: any) => {
  if (props.infoBeforeCallback) {
    const next = props.infoBeforeCallback()
    if (next) {
      infoFn(primaryKey, data)
    }
  } else {
    infoFn(primaryKey, data)
  }
}

const infoFn = (primaryKey: string, data?: any) => {
  emit('update:operatingTypeProps', 'edit')
  const originalUrl = `${props.queryOneInterface}/${primaryKey}`
  const url = renderTemplate(originalUrl, props.formInline)
  global.$http
    .request({
      url,
      method: props.queryOneInterfaceMethod,
      data,
    })
    .then((res: any) => {
      operatingType.value = 'edit'
      const editTitle = props.customizeDialogTitle?.editTitle
      dialogTitle.value = editTitle ? editTitle : t('el.formBase.editBtnText')
      Object.assign(cloneAddForm, cloneDeep(res['data']))
      // 判断是弹窗还是全屏弹窗
      if (props.dialogType === 'dialog') {
        dialogVisible.value = true
      } else {
        dialogHeaderVisible.value = true
      }
      if (props.infoControllerCallback) {
        props.infoControllerCallback(res['data'])
      }
    })
}

const details: FormBaseContext['info'] = (primaryKey: string, data?: any) => {
  addFormDisabled.value = true
  draftBtnDisabled.value = true
  initiateProcessBtnDisabled.value = true
  if (props.infoBeforeCallback) {
    const next = props.infoBeforeCallback()
    if (next) {
      detailsFn(primaryKey, data)
    }
  } else {
    detailsFn(primaryKey, data)
  }
}

const detailsFn = (primaryKey: string, data: any) => {
  emit('update:operatingTypeProps', 'info')
  const originalUrl = `${props.queryOneInterface}/${primaryKey}`
  const url = renderTemplate(originalUrl, props.formInline)
  global.$http
    .request({
      url,
      method: props.queryOneInterfaceMethod,
      data,
    })
    .then((res: any) => {
      operatingType.value = 'info'
      const infoTitle =
        props.customizeDialogTitle && props.customizeDialogTitle.infoTitle
      dialogTitle.value = infoTitle ? infoTitle : t('el.formBase.infoText')
      Object.assign(cloneAddForm, cloneDeep(res['data']))
      // 判断是弹窗还是全屏弹窗
      if (props.dialogType === 'dialog') {
        dialogVisible.value = true
      } else {
        dialogHeaderVisible.value = true
      }
      if (props.infoControllerCallback) {
        props.infoControllerCallback(res['data'])
      }
    })
    .catch(() => {
      beforeCloseFn()
    })
}

const del = () => {
  let selection: string | any[] = []
  if (props.rowSingle) {
    selection = multipleSelection.value
  } else {
    selection = currentRow.value ? [currentRow.value] : []
  }
  if (selection.length === 0) {
    ElMessage({
      type: 'warning',
      message: localeTextEmptyOption.value,
      duration: props.duration,
    })
  } else if (selection.length >= 2) {
    ElMessage({
      type: 'warning',
      message: localeTextEmptyOptionOne.value,
      duration: props.duration,
    })
  } else {
    const id = selection[0][props.primaryKey ? props.primaryKey : '']
    if (props.delBeforeCallback) {
      props.delBeforeCallback(id).then((res) => {
        if (res) {
          deleteRow(id)
        }
      })
    } else {
      deleteRow(id)
    }
  }
}

const batchDel = () => {
  const selection = multipleSelection.value
  if (selection.length === 0) {
    ElMessage({
      type: 'warning',
      message: localeTextEmptyOption.value,
      duration: props.duration,
    })
  } else {
    const ids = selection.map((item) => item[props.primaryKey])
    if (props.delBeforeCallback) {
      props.delBeforeCallback(ids).then((res) => {
        if (res) {
          deleteRow(ids)
        }
      })
    } else {
      deleteRow(ids)
    }
  }
}

const deleteRow: FormBaseContext['deleteRow'] = (ids: any) => {
  if (typeof ids === 'string') {
    ids = [ids]
  }
  ElMessageBox.confirm(localeTextDelStr.value, t('el.formBase.title'), {
    confirmButtonText: t('el.formBase.confirm'),
    cancelButtonText: t('el.formBase.cancel'),
    type: 'warning',
  })
    .then(() => {
      if (!props.isBatchDelete) {
        global.$http
          .request({
            url: props.deleteInterface,
            method: props.deleteInterfaceMethod,
            data: ids,
          })
          .then((res: any) => {
            if (res.code === global.is_OK) {
              setTimeout(() => {
                ElMessage({
                  type: 'success',
                  message: localeTextDelSuccess.value,
                  duration: props.duration,
                })
                query()
              }, 500)
              if (props.delControllerCallback) {
                props.delControllerCallback()
              }
            }
          })
      } else {
        global.$http
          .request({
            url: `${props.deleteInterface}/${ids[0]}`,
            method: props.deleteInterfaceMethod,
          })
          .then((res: any) => {
            if (res.code === global.is_OK) {
              setTimeout(() => {
                ElMessage({
                  type: 'success',
                  message: localeTextDelSuccess.value,
                  duration: props.duration,
                })
                query()
              }, 500)
              if (props.delControllerCallback) {
                props.delControllerCallback()
              }
            }
          })
      }
    })
    .catch(() => {
      // eslint-disable-next-line no-console
      console.log('取消')
    })
}

const save = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields): any => {
    if (valid) {
      if (props.addParamControllerCallback) {
        props.addParamControllerCallback().then(() => {
          submit()
        })
      } else if (props.addParamPromiseControllerCallback) {
        props.addParamPromiseControllerCallback(vm).then((res: any) => {
          if (res) {
            submit()
          }
        })
      } else if (props.addParamControllerPreventCallback) {
        props.addParamControllerPreventCallback()
      } else {
        submit()
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('error submit!', fields)
      return false
    }
  })
}

const submit: FormBaseContext['submit'] = (params?: any) => {
  formBtnLoading.value = true
  if (operatingType.value === 'add') {
    const url = renderTemplate(props.saveInterface || '', cloneAddForm)
    global.$http
      .request({
        url,
        method: props.saveInterfaceMethod,
        data: params ? params : cloneAddForm,
      })
      .then((res: any) => {
        if (res.code === global.is_OK) {
          setTimeout(() => {
            ElMessage({
              type: 'success',
              message: localeTextAddSuccess.value,
              duration: props.duration,
            })
            beforeClose()
            query()
          }, 500)
          if (props.addControllerCallback) {
            props.addControllerCallback(res)
          }
        }
        formBtnLoading.value = false
      })
      .finally(() => {
        formBtnLoading.value = false
      })
      .catch(() => {
        formBtnLoading.value = false
      })
  } else {
    const url = renderTemplate(props.updateInterface || '', cloneAddForm)
    global.$http
      .request({
        url,
        method: props.updateInterfaceMethod,
        data: params ? params : cloneAddForm,
      })
      .then((res: any) => {
        if (res.code === global.is_OK) {
          setTimeout(() => {
            ElMessage({
              type: 'success',
              message: localeTextEditSuccess.value,
              duration: props.duration,
            })
            beforeClose()
            query()
          }, 500)
          if (props.addControllerCallback) {
            props.addControllerCallback(res)
          }
        }
        formBtnLoading.value = false
      })
      .finally(() => {
        formBtnLoading.value = false
      })
      .catch(() => {
        formBtnLoading.value = false
      })
  }
}

const beforeClose = () => {
  if (props.dialogBeforeClose) {
    props.dialogBeforeClose()
  } else {
    beforeCloseFn()
  }
}

const beforeCloseFn: FormBaseContext['beforeCloseFn'] = () => {
  addFormRef.value?.resetFields()
  Object.keys(cloneAddForm).forEach((key) => {
    delete cloneAddForm[key]
  })
  Object.assign(cloneAddForm, JSON.parse(JSON.stringify(props.addForm)))
  dialogVisible.value = false
  dialogHeaderVisible.value = false
  operatingType.value = 'add'
  addFormDisabled.value = false
  const addTitle = props.customizeDialogTitle?.addTitle
  formBtnLoading.value = false
  draftBtnLoading.value = false
  initiateProcessBtnLoading.value = false
  draftBtnDisabled.value = false
  initiateProcessBtnDisabled.value = false
  storageBtnLoading.value = false
  dialogTitle.value = addTitle ? addTitle : t('el.formBase.addBtnText')
}

// 保存草稿事件
const draft = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields): any => {
    if (valid) {
      if (props.draftParamControllerCallback) {
        // this
        props.draftParamControllerCallback().then(() => {
          draftSubmit()
        })
      } else if (props.draftParamPromiseControllerCallback) {
        // this
        props.draftParamPromiseControllerCallback().then((res) => {
          if (res) {
            draftSubmit()
          }
        })
      } else if (props.draftParamControllerPreventCallback) {
        // this
        props.draftParamControllerPreventCallback()
      } else {
        draftSubmit()
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('error submit!', fields)
      return false
    }
  })
}

const draftSubmit: FormBaseContext['draftSubmit'] = (params?: any) => {
  draftBtnLoading.value = true
  initiateProcessBtnLoading.value = true
  storageBtnLoading.value = true
  const url = renderTemplate(props.draftInterface || '', cloneAddForm)
  global.$http
    .request({
      url,
      method: props.draftInterfaceMethod,
      data: params ? params : cloneAddForm,
    })
    .then((res: any) => {
      if (res.code === global.is_OK) {
        setTimeout(() => {
          ElMessage({
            type: 'success',
            message: localeTextDraftSuccess.value,
            duration: props.duration,
          })
          beforeClose()
          query()
          draftBtnLoading.value = false
          initiateProcessBtnLoading.value = false
          storageBtnLoading.value = false
        }, 500)
        if (props.addControllerCallback) {
          props.addControllerCallback(res)
        }
      }
      draftBtnLoading.value = false
      initiateProcessBtnLoading.value = false
      storageBtnLoading.value = false
    })
    .finally(() => {
      draftBtnLoading.value = false
      initiateProcessBtnLoading.value = false
      storageBtnLoading.value = false
    })
    .catch(() => {
      draftBtnLoading.value = false
      initiateProcessBtnLoading.value = false
      storageBtnLoading.value = false
      if (props.draftControllerErrorCallback) {
        props.draftControllerErrorCallback()
      }
    })
}

// 发起流程事件
const startProcess = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields): any => {
    if (valid) {
      if (props.processParamControllerCallback) {
        // this
        props.processParamControllerCallback().then(() => {
          processSubmit()
        })
      } else if (props.processParamPromiseControllerCallback) {
        // this
        props.processParamPromiseControllerCallback().then((res) => {
          if (res) {
            processSubmit()
          }
        })
      } else if (props.processParamControllerPreventCallback) {
        // this
        props.processParamControllerPreventCallback()
      } else {
        processSubmit()
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('error submit!', fields)
      return false
    }
  })
}

const processSubmit: FormBaseContext['processSubmit'] = (params?: any) => {
  draftBtnLoading.value = true
  initiateProcessBtnLoading.value = true
  storageBtnLoading.value = true
  global.$openRunFlow({
    handleId: cloneAddForm.handleId,
    bidId: cloneAddForm.bidId,
    bpmKey: cloneAddForm.bpmKey || '',
    peFormBase: vm,
    success(flowDialogForm: any, app: any) {
      const fn = (newFlowDialogForm: any) => {
        let dataParams = {
          ...newFlowDialogForm,
          ...(params ? params : cloneAddForm),
        }
        if (props.processRunFlowParamsControllerCallback) {
          dataParams = props.processRunFlowParamsControllerCallback(dataParams)
        }
        const url = renderTemplate(props.processInterface || '', cloneAddForm)
        global.$http
          .request({
            url,
            method: props.processInterfaceMethod,
            data: dataParams,
          })
          .then((res: any) => {
            if (res['code'] === global.is_OK) {
              setTimeout(() => {
                ElMessage({
                  type: 'success',
                  message: localeTextProcessSuccess.value,
                  duration: props.duration,
                })
                app.close()
                beforeClose()
                query()
                draftBtnLoading.value = false
                initiateProcessBtnLoading.value = false
                storageBtnLoading.value = false
              }, 500)
              if (props.processControllerCallback) {
                props.processControllerCallback(res)
              }
            } else {
              draftBtnLoading.value = false
              initiateProcessBtnLoading.value = false
              storageBtnLoading.value = false
              app.callback((config: any) => {
                fn(config)
              }, res)
            }
          })
          .catch((err: any) => {
            draftBtnLoading.value = false
            initiateProcessBtnLoading.value = false
            storageBtnLoading.value = false
            app.callback((config: any) => {
              fn(config)
            }, err)
            if (props.processControllerErrorCallback) {
              props.processControllerErrorCallback()
            }
          })
      }
      fn(flowDialogForm)
    },
    error(app: any) {
      draftBtnLoading.value = false
      initiateProcessBtnLoading.value = false
      storageBtnLoading.value = false
      app.close()
    },
  })
}

// 暂存按钮事件
const storage = () => {
  draftBtnLoading.value = true
  initiateProcessBtnLoading.value = true
  storageBtnLoading.value = true
  if (props.storageCallback) {
    props.storageCallback().then(() => {
      setTimeout(() => {
        ElMessage({
          type: 'success',
          message: localeTextEditSuccess.value,
          duration: props.duration,
        })
        beforeClose()
        query()
        draftBtnLoading.value = false
        initiateProcessBtnLoading.value = false
        storageBtnLoading.value = false
      }, 500)
    })
  }
  if (props.storageControllerPreventCallback) {
    props.storageControllerPreventCallback().then((res: any) => {
      if (res) {
        setTimeout(() => {
          ElMessage({
            type: 'success',
            message: localeTextEditSuccess.value,
            duration: props.duration,
          })
          beforeClose()
          query()
          draftBtnLoading.value = false
          initiateProcessBtnLoading.value = false
          storageBtnLoading.value = false
        }, 500)
      } else {
        setTimeout(() => {
          draftBtnLoading.value = false
          initiateProcessBtnLoading.value = false
          storageBtnLoading.value = false
        }, 500)
      }
    })
  }
}

const handleSizeChange = (val: number) => {
  pagination.value.pageSize = val
  pagination.value.pageNum = 1
  query()
}

const handleCurrentChange = (val: number) => {
  pagination.value.pageNum = val
  query()
}

const handleChangeFlowStatus = () => {
  query()
}

const handleRowDblclick = (row: any) => {
  if (props.isDoubleClickDetails) {
    if (props.hasFlow) {
      if (row.formUrl && row.procInstId) {
        // 默认打开流程详情是无法进行操作
        row.optionType = 'end'
        global.$openFlowBox({
          row,
          peFormBase: vm,
        })
      } else {
        details(row[props.primaryKey])
      }
    } else {
      details(row[props.primaryKey])
    }
  } else {
    emit('table-row-dblclick', row)
  }
}

const handleTableCurrentChange = (row: any) => {
  currentRow.value = row
  emit('table-current-change', row)
}

const handleTableSelectionChange = (row: any) => {
  multipleSelection.value = row
  emit('table-selection-change', row)
}

const handleClickInfo = (columns: FormBaseColumnsItem, row: any) => {
  if (columns.isDetails) {
    if (props.hasFlow) {
      if (row.formUrl && row.procInstId) {
        // 默认打开流程详情是无法进行操作
        row.optionType = 'end'
        global.$openFlowBox({
          row,
          peFormBase: vm,
        })
      } else {
        details(row[props.primaryKey])
      }
    } else {
      details(row[props.primaryKey])
    }
  }
}

const handleTableSortChange = (sort: any) => {
  orderArray.value = sort
  query()
}

const setData: FormBaseContext['setData'] = (data: any) => {
  tableData.value = data
}

const doLayout: FormBaseContext['doLayout'] = () => {
  peTable?.value?.doLayout()
}

const validate: FormBaseContext['validate'] = (callback?: any) => {
  return addFormRef.value?.validate(callback)
}

const setFormBtnLoading: FormBaseContext['setFormBtnLoading'] = (
  val: boolean
) => {
  formBtnLoading.value = val
}

const setAddFormDisabled: FormBaseContext['setAddFormDisabled'] = (
  val: boolean
) => {
  addFormDisabled.value = val
}

const reloadTable: FormBaseContext['reloadTable'] = () => {
  isShowDataTable.value = false
  nextTick(() => {
    isShowDataTable.value = true
  })
}

const setupClick = () => {
  if (customSetUpCallback.value) {
    customSetUpCallback.value(vm)
  }
}

const handleToggleExpand = () => {
  if (props.isVirtuallyTable) {
    tableDefaultExpandAll.value = !tableDefaultExpandAll.value
    peTable?.value?.dataTableRef().setAllTreeExpand(tableDefaultExpandAll.value)
    peTable?.value?.dataTableRef().refreshColumn()
  } else {
    peTable?.value?.setRefreshTable(false)
    tableDefaultExpandAll.value = !tableDefaultExpandAll.value
    nextTick(() => {
      peTable?.value?.setRefreshTable(true)
    })
  }
}

provide(formBaseContextKey, {
  ...toRefs(props),
  query,
  search,
  add,
  info,
  deleteRow,
  details,
  setData,
  submit,
  draftSubmit,
  processSubmit,
  beforeCloseFn,
  doLayout,
  validate,
  setFormBtnLoading,
  setAddFormDisabled,
})

defineExpose({
  /**
   * @description pagination
   */
  pagination,
  /**
   * @description addFormDisabled
   */
  addFormDisabled,
  /**
   * @description formBtnLoading
   */
  formBtnLoading,
  /**
   * @description tableData
   */
  tableData,
  /**
   * @description cloneAddForm
   */
  cloneAddForm,
  /**
   * @description currentRow
   */
  currentRow,
  /**
   * @description multipleSelection
   */
  multipleSelection,
  /**
   * @description peTable
   */
  peTable,
  /**
   * @description query
   */
  query,
  /**
   * @description search
   */
  search,
  /**
   * @description add
   */
  add,
  /**
   * @description info
   */
  info,
  /**
   * @description deleteRow
   */
  deleteRow,
  /**
   * @description details
   */
  details,
  /**
   * @description setData
   */
  setData,
  /**
   * @description submit
   */
  submit,
  /**
   * @description draftSubmit
   */
  draftSubmit,
  /**
   * @description processSubmit
   */
  processSubmit,
  /**
   * @description beforeCloseFn
   */
  beforeCloseFn,
  /**
   * @description doLayout
   */
  doLayout,
  /**
   * @description validate
   */
  validate,
  /**
   * @description setFormBtnLoading
   */
  setFormBtnLoading,
  /**
   * @description setAddFormDisabled
   */
  setAddFormDisabled,
  /**
   * @description draftBtnLoading
   */
  draftBtnLoading,
  /**
   * @description initiateProcessBtnLoading
   */
  initiateProcessBtnLoading,
  /**
   * @description draftBtnDisabled
   */
  draftBtnDisabled,
  /**
   * @description initiateProcessBtnDisabled
   */
  initiateProcessBtnDisabled,
  /**
   * @description storageBtnLoading
   */
  storageBtnLoading,
  /**
   * @description reloadTable
   */
  reloadTable,
})
</script>
